<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t($route.name) }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input id="filter-input" v-model="filter" type="search" @input="Data(parent)"
              :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>

          <!-- Excel -->
          <button class="tool-btn" @click="Xlsx()" title="Excel">
            <b-icon icon="download"></b-icon> Excel
          </button>

          <!-- Qo'shish -->
          <button class="add-btn" @click="Href('/malumot/product/create')" v-if="rule.change==true">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}<sup>ins</sup>
          </button>

          <!-- Fayl yuklash -->
          <button class="tool-btn" v-b-modal.modal-upload type="button" title="Fayl yuklash">
            <b-icon icon="file-earmark-arrow-up"></b-icon>
          </button>

          <!-- Shtrix kod (alohida sahifa) -->
          <button class="tool-btn" @click="Href('/product/barcode','blank')" v-if="rule.change==true" title="Shtrix kod (alohida sahifa)">
            <b-icon icon="upc-scan"></b-icon>
          </button>

          <!-- 🏷 Tanlangan shtrixlar (modal) — badge bilan -->
          <button class="tool-btn barcode-fab" :class="{ active: barcodeSelection.length > 0 }"
            @click="showBarcodeModal = true"
            :title="`Shtrix chiqarish (${barcodeSelection.length} ta)`">
            <b-icon icon="upc"></b-icon>
            <span v-if="barcodeSelection.length" class="badge-count">{{ barcodeSelection.length }}</span>
          </button>

          <!-- Yangilash -->
          <button class="refresh-btn" @click="Data(parent)" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px"></th>
                <th>{{ $t("Номи") }}</th>
                <th style="width: 110px">{{ $t("Артикул") }}</th>
                <th class="th-right">{{ $t("Қолдиқ") }}</th>
                <th class="th-right">{{ $t("Тан нарх") }}</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}$</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}$</th>
                <th style="width: 120px; text-align: center;">{{ $t("AMALLAR") }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- Orqaga qaytish -->
              <tr class="navigation-row" @dblclick="Data(parent)">
                <td>
                  <b-icon icon="arrow-left-circle-fill" variant="secondary"></b-icon>
                </td>
                <td style="width: 30%;">
                  <button type="button" class="go-back-btn">..</button>
                </td>
                <td colspan="8"></td>
              </tr>

              <!-- Ma'lumotlar -->
              <tr v-for="(item, index) in items" :key="index"
                :class="{ 'folder-row': item.is_folder }">
                <td @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.is_folder">
                    <b-icon icon="folder-fill" variant="warning" font-scale="1.1"></b-icon>
                  </span>
                  <span class="id-text">{{ item.id }}</span>
                </td>
                <td style="cursor: pointer;" @dblclick="Select(item)">
                  <button type="button" :class="['item-name', { 'folder-name': item.is_folder }]">
                    <span v-if="item.parent_id > 0" style="padding:0 15px;"></span>
                    {{ item.extra_name }}
                  </button>
                </td>
                <td class="td-code" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.code" class="code-badge">{{ item.code }}</span>
                  <span v-else class="code-empty">—</span>
                </td>
                <td class="td-right td-balance" @dblclick="Select(item)" style="cursor: pointer;">
                  {{ item.balance | numFormat }}
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.body_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.chakana_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.optom_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.chakana_dollar_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.optom_dollar_price | numFormat }}
                  </span>
                </td>
                <td>
                  <div class="actions">
                    <button type="button" class="icon-btn barcode" title="Shtrixga qo'shish"
                      v-if="!item.is_folder" @click="addToBarcodeSelection(item)">
                      <b-icon icon="upc"></b-icon>
                    </button>
                    <router-link :to="{ name: 'Продукт ўзгартириш', params: { id: item.id } }">
                      <button type="button" class="icon-btn edit">
                        <b-icon icon="pencil-square"></b-icon>
                      </button>
                    </router-link>
                    <button type="button" class="icon-btn del" @click="Trash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Ko'proq yuklash -->
              <tr v-if="add==true">
                <td colspan="10" class="load-more-row">
                  <button class="load-more-btn" @click="Add()">{{ $t('Eshyo') }}</button>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="items.length === 0">
                <td colspan="10" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ items.length }}</b> ta mahsulot
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════ 🏷 SHTRIX CHIQARISH MODAL ═══════════════ -->
    <div v-if="showBarcodeModal" class="bc-overlay" @click.self="showBarcodeModal = false">
      <div class="bc-modal">
        <div class="bc-head">
          <h3 class="bc-title">🏷 Shtrix kod chiqarish ({{ barcodeSelection.length }} ta)</h3>
          <button class="bc-close" @click="showBarcodeModal = false">&times;</button>
        </div>

        <div class="bc-body">
          <!-- Sozlamalar -->
          <div class="bc-options">
            <div class="bc-opt">
              <label class="bc-label">Narx turi</label>
              <select v-model="barcodePriceType" class="bc-select">
                <option value="chakana">Chakana</option>
                <option value="optom">Optom</option>
              </select>
            </div>
            <div class="bc-opt">
              <label class="bc-toggle">
                <input type="checkbox" v-model="barcodeShowPrice"> Narxni chop etish
              </label>
            </div>

            <!-- 🎯 Ommaviy son o'rnatish -->
            <div class="bc-opt bc-bulk">
              <label class="bc-label">Hammaga son</label>
              <div class="bc-bulk-row">
                <input v-model.number="barcodeBulkCount" type="number" min="0"
                  class="bc-qty" placeholder="5" @keyup.enter="applyBarcodeBulk()" />
                <button class="bc-btn-apply" @click="applyBarcodeBulk()" title="Hammasiga qo'llash">
                  Qo'llash
                </button>
              </div>
            </div>

            <div class="bc-opt" style="margin-left:auto">
              <button class="bc-btn-clear" @click="barcodeSelection = []">
                <b-icon icon="trash"></b-icon> Tozalash
              </button>
            </div>
          </div>

          <!-- Tanlanganlar jadvali -->
          <div v-if="barcodeSelection.length === 0" class="bc-empty">
            Ro'yxat bo'sh. Mahsulot ro'yxatidan 🏷 tugmasini bosib qo'shing.
          </div>
          <table v-else class="bc-table">
            <thead>
              <tr>
                <th style="width:40px">№</th>
                <th>Mahsulot</th>
                <th style="width:150px">Shtrix</th>
                <th style="width:120px">Narx</th>
                <th style="width:100px">Soni</th>
                <th style="width:50px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, i) in barcodeSelection" :key="it.id">
                <td>{{ i + 1 }}</td>
                <td>
                  <div class="bc-pname">{{ it.name }}</div>
                  <div v-if="!it.shtrix_kod" class="bc-warn">⚠️ Shtrix kod yo'q</div>
                </td>
                <td class="bc-mono">{{ it.shtrix_kod || '—' }}</td>
                <td>
                  {{ Number(barcodePriceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }}
                </td>
                <td>
                  <input v-model.number="it.count" type="number" min="1" class="bc-qty" />
                </td>
                <td>
                  <button class="bc-btn-x" @click="barcodeSelection.splice(i, 1)" title="O'chirish">
                    <b-icon icon="x-lg"></b-icon>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" style="text-align:right; font-weight:800">JAMI:</td>
                <td colspan="2" style="font-weight:900; color:#5850ec">
                  {{ barcodeSelection.reduce((s, it) => s + Number(it.count || 0), 0) }} ta
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="bc-foot">
          <button class="bc-btn-cancel" @click="showBarcodeModal = false">Bekor</button>
          <button class="bc-btn-print"
            :disabled="barcodeSelection.length === 0 || !barcodeSelection.some(it => it.shtrix_kod && it.count > 0)"
            @click="printBarcodes()">
            <b-icon icon="printer-fill"></b-icon> Chop etish
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ YASHIRIN PRINT MARKUP ═══════════════ -->
    <div class="bc-mybody" style="display:none">
      <span v-for="(it, i) in barcodeSelection" :key="'p'+i">
        <template v-if="it.shtrix_kod && it.count > 0">
          <div v-for="n in Number(it.count)" :key="'p'+i+'-'+n" class="bc-page">
            <div class="bc-name">{{ it.name }}</div>
            <div v-if="barcodeShowPrice" class="bc-price">
              {{ Number(barcodePriceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }} so'm
            </div>
            <div class="bc-barcode-wrap">
              <barcode :value="it.shtrix_kod" width="3.5" height="110" font-size="22" displayValue></barcode>
            </div>
          </div>
        </template>
      </span>
    </div>

    <!-- SKLAD COMPONENT -->
    <b-container fluid>
      <sklad :datas="datas"></sklad>

      <!-- FAYL YUKLASH MODAL -->
      <b-modal id="modal-upload" title="" size="xl" hide-footer @shown="Shovedform">
        <form>
          <div class="row">
            <div class="col-md-6">
              <label for="">Склад</label>
            </div>
            <div class="col-md-6">
              <v-select :clearable="false" class="md-input" :options="skladlist" v-model="datas.sklad_id"
                :reduce="name => name.id" label="name">
                <template #search="{attributes, events}">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button type="button" class="modallist" v-b-modal.modal-skladlist>
                    <b-icon icon="three-dots"></b-icon>
                  </button>
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <em><b>{{ search }}</b></em>
                    {{ $t("бўйича маьлумот йўқ") }}
                    <button type="button" @click="unit.name = search" v-b-modal.modal-unit class="pluss">
                      +
                    </button>
                    <b>insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
            </div>
            <div class="col-md-6">
              <label for="">{{ $t('Тўлов тури') }}</label>
            </div>
            <div class="col-md-6">
              <v-select :clearable="false" class="form-control-sm required md-input" :options="paytypelist"
                v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
              </v-select>
            </div>
            <div class="col-md-6">
              <label for="">Курс</label>
            </div>
            <div class="col-md-6">
              <input type="number" v-model="datas.dollar_rate" class="form-control">
            </div>
          </div>
          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
          <button type="button" class="btn btn-primary" @click="Yuklash()">
            {{ $t("Сақлаш") }}
          </button>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
  import Top from "../../Layout/Top.vue";
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import $ from "jquery";
  import { print } from "../../../components/mixins/print.js";
  import filterFunction from "../../../utils/filterFunction";
  import { Sklad } from "@/pages";
  import VueBarcode from 'vue-barcode';
  export default {
    components: { Sklad, Top, VueAutoVirtualScrollList, barcode: VueBarcode },
    mixins: [print],
    data() {
      return {
        file: "",
        send:false,
        add:true,
        limit: 100,
        page:1,
        parent: 0,
        datas: {
          file: "",
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          pay_type_id:1,
          dollar_rate:1,
        },
        paytypelist:[],
        items: [],
        sklad: "",
        skladlist: [],
       totalRows: 1,
        currentPage: 1,
        filter: "",

        // 🏷 Shtrix tanlash
        showBarcodeModal: false,
        barcodeSelection: [],        // [{ id, name, shtrix_kod, chakana_price, optom_price, count }]
        barcodePriceType: 'chakana', // chakana | optom
        barcodeShowPrice: true,
        barcodeBulkCount: 1,
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key };
          });
      }
    },
    mounted: function() {
            this.Data(this.$store.state.parent_id);
    },
    created: function () {
    this.parent=this.$store.state.parent_id;
      let self = this;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      axios.get("api/v1/pay-type").then(function(response) {
        self.paytypelist = response.data;
      });
      axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.datas.dollar_rate=response.data.rate;
        });
      // self.Interval();
    },
    methods: {
      filterFunction,
      Dowloadfile(file){
        let self=this;
        axios({
                    url: 'api/v1/uploads/'+file, // File URL Goes Here
                    method: 'GET',
                    responseType: 'blob',
                }).then((res) => {
                     var FILE = window.URL.createObjectURL(new Blob([res.data]));
                     var docUrl = document.createElement('a');
                     docUrl.href = FILE;
                     docUrl.setAttribute('download', file);
                     document.body.appendChild(docUrl);
                     docUrl.click();
                });

      },
      // ════════ 🏷 SHTRIX TANLASH ════════
      applyBarcodeBulk() {
        const n = Math.max(0, Math.floor(Number(this.barcodeBulkCount || 0)));
        this.barcodeSelection.forEach(it => {
          if (it.shtrix_kod) it.count = n;
        });
      },

      addToBarcodeSelection(item) {
        // Mavjudligini tekshirish
        const idx = this.barcodeSelection.findIndex(x => x.id === item.id);
        if (idx >= 0) {
          this.barcodeSelection[idx].count += 1;
          return;
        }
        const entry = {
          id:    item.id,
          name:  item.extra_name || item.name || '—',
          shtrix_kod: '',
          chakana_price: (item.price_register && item.price_register.chakana_price) || 0,
          optom_price:   (item.price_register && item.price_register.optom_price)   || 0,
          count: 1,
        };
        // Shtrix kodni serverdan olib kelish
        axios.get(`api/v1/product/id/${item.id}`).then(r => {
          if (r.data && r.data.shtrix_table && r.data.shtrix_table[0]) {
            entry.shtrix_kod = r.data.shtrix_table[0].shtrix_kod || '';
          }
        }).catch(() => {});
        this.barcodeSelection.push(entry);
      },

      printBarcodes() {
        const valid = this.barcodeSelection.filter(it => it.shtrix_kod && Number(it.count) > 0);
        if (!valid.length) {
          alert("Shtrix kodli va soni > 0 bo'lgan mahsulot topilmadi");
          return;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const html = $('.bc-mybody').html();
            if (!html) { alert('Print markup tayyor emas'); return; }
            const w = window.open('', '_blank', 'width=420,height=700');
            w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Shtrix</title>
              <style>
                /* Sticker o'lchami: 58×40mm (Directory/Product/Index.vue bilan bir xil) */
                @page { size: 58mm 40mm; margin: 0; }
                * { box-sizing: border-box; }
                html, body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
                .bc-page {
                  width: 58mm; height: 40mm;
                  page-break-after: always; page-break-inside: avoid;
                  display: flex; flex-direction: column;
                  align-items: center; justify-content: center;
                  gap: 0.5mm; padding: 1mm 0; overflow: hidden;
                }
                .bc-page:last-child { page-break-after: auto; }
                .bc-name {
                  font-size: 8pt; font-weight: 800;
                  text-align: center; line-height: 1.1;
                  max-height: 8mm; overflow: hidden;
                  width: 100%; word-break: break-word;
                  padding: 0 1mm;
                }
                .bc-price { font-size: 13pt; font-weight: 900; text-align: center; line-height: 1; }
                .bc-barcode-wrap {
                  width: 100%;
                  display: flex; justify-content: center; align-items: center;
                  flex: 1;
                  overflow: hidden;
                }
                .vue-barcode-element { width: 100% !important; display: block; }
                .vue-barcode-element svg {
                  width: 100% !important;
                  height: auto !important;
                  max-height: 26mm;
                  display: block;
                  image-rendering: -webkit-optimize-contrast;
                  image-rendering: crisp-edges;
                  shape-rendering: crispEdges;
                }
                .vue-barcode-element text {
                  font-size: 11pt !important;
                  font-weight: 800 !important;
                  letter-spacing: 1.2px;
                }
              </style>
              </head><body>${html}</body></html>`);
            w.document.close();
            // Print tugagandan keyin oynani avtomatik yopish
            w.onafterprint = () => { try { w.close(); } catch (_) {} };
            setTimeout(() => {
              w.focus();
              w.print();
              // Fallback: ba'zi brauzerlarda onafterprint ishlamaydi — 2 sek'da majburiy yopish
              setTimeout(() => { try { w.close(); } catch (_) {} }, 2000);
            }, 300);
          }, 100);
        });
      },

      Xlsx(){
        let self=this;
        axios({
          method: "post",
          url: "api/v1/download/product",
          data: {
            sklad_id: parseInt(localStorage.getItem("sklad_id"))
          }
        })
          .then(function (response) {
          self.Dowloadfile(response.data);
          });
      },
      Add(){
        let self = this;
        self.page+=1;
        if (localStorage.getItem("sklad_id") > 0) {
        var datetime = null;
        var keyword = "";
        if (self.filter.length > 2) {
          keyword = self.filter;
        }
        axios({
          method: "post",
          url: "api/v1/product/all-price-balance/" + self.items[0].parent_id,
          data: {
            sklad_id: localStorage.getItem("sklad_id"),
            datetime: datetime,
            keyword: keyword,
            page:self.page,
            limit:self.limit
          }
        })
          .then(function (response) {
            var b = self.items.concat(response.data);
            self.items = b
            if(response.data.length==self.limit){
            }else{
              self.add=false;
             }

          });
        }
      },
      Select(item) {
        this.$store.state.parent_id=item.parent_id;
      if(item.is_folder==false){
        this.$router.push({ path: '/malumot/product/update/' + item.id });
      }else{
        this.parent=item.parent_id;
      this.Data(item.id);
      setTimeout(() => {
        $('.atable:eq(0)').focus()
      }, 100);
      }
    } ,
      Update(record, index) {
        if (this.rule.open == true) {
          this.$router.push({ path: '/malumot/product/update/' + record.id });
        }
      },
      handleFileUpload() {
        this.file = this.$refs.file.files;
        this.datas.file = URL.createObjectURL(this.$refs.file.files[0]);
      },
      Bazayuklash() {
        axios({
          method: "get",
          url: "api/v1/download/dump"
        }).then(function (response) { });
      },
      Yuklash() {
        let self = this;
        if(self.send==false){
          self.send=true;
          let formData = new FormData();
        let file = self.file[0];
        formData.append("file_name", file);
        formData.append("sklad_id", this.datas.sklad_id);
        formData.append("pay_type_id", this.datas.pay_type_id);
        formData.append("dollar_rate", this.datas.dollar_rate);
        formData.append("user_id", localStorage.getItem("user_id"));
        axios({
          method: "post",
          url: "api/v1/upload/product",
          data: formData
        }).then(function (response) {
          self.datas.file="";
          self.file="";
          self.send=false;
          self.$bvModal.hide("modal-upload");
          self.Data(self.parent);
        }).catch(function(error){
          self.send=false;
        });
        }else{
          console.log('not');
        }
      },
      Data(parent) {
        let self = this;
        if (localStorage.getItem("sklad_id") > 0) {
        var datetime = null;
        var keyword = "";
        if (self.filter.length > 2) {
          keyword = self.filter;
        }
        axios({
          method: "post",
          url: "api/v1/product/all-price-balance/" + parent,
          data: {
            sklad_id: localStorage.getItem("sklad_id"),
            datetime: datetime,
            keyword: keyword,
            page:self.page,
            limit:self.limit
          }
        })
          .then(function (response) {
            self.items = response.data;
            self.page=1;
            if (response.data.length>0 && response.data[0].parent_id > 0) {
              axios
                .get("api/v1/product/id/" + response.data[0].parent_id)
                .then(function (response) {
                  self.parent = response.data.parent_id;
                });
            }
          });
        }else {
        self.productlist = [];
        }
      },
      Interval() {
        window.setInterval(() => {
          this.Data(self.parent);
        }, 60000);
      },
      Trash(id) {
        let self = this;
        self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
              method: "delete",
              url: "api/v1/product/id/" + id
            }).then(function (response) {
              self.Data(self.parent);
              self.Cacheclear();
            });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
          .catch(function () { });
      },
      Cacheclear() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/cache-clear/all-price-balance",
        data: {
          sklad_id: localStorage.getItem("sklad_id"),
          datetime: localStorage.getItem("created_at")
        }
      }).then(function(response) {
        self.Data(self.parent);
      });
    },
      Shovedform() {
        this.$refs.file.focus();
      }
    }
  };
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* SEARCH */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 220px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  transition: 0.2s;
}

.add-btn:hover {
  transform: translateY(-1px);
}

.add-btn sup {
  font-weight: 400;
  opacity: 0.7;
}

.tool-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
}

.tool-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.refresh-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table thead {
  position: sticky;
  top: 0;
  z-index: 5;
}

.custom-table th {
  background: white;
  padding: 16px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f5f9;
}

.th-right {
  text-align: right;
}

.custom-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.td-balance {
  font-weight: 700;
  color: #2c3e50;
}

/* 🆕 Артикул ustun */
.td-code { text-align: center; }
.code-badge {
  display: inline-block;
  background: #ede9fe;
  color: #5850ec;
  font-family: 'JetBrains Mono', 'Consolas', monospace;
  font-weight: 700;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 6px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}
.code-empty {
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 600;
}

.custom-table tbody tr:hover:not(.navigation-row) {
  background: #faf8ff;
}

/* NAVIGATION */
.navigation-row {
  cursor: pointer;
}

.navigation-row:hover td {
  color: #a142f4;
  background: #faf8ff;
}

.go-back-btn {
  background: none;
  border: none;
  font-weight: 700;
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
}

/* FOLDER */
.folder-row {
  background-color: #fffbeb;
}

.folder-row:hover {
  background-color: #fef3c7 !important;
}

.id-text {
  float: right;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
}

.item-name {
  background: none;
  border: none;
  font-weight: 600;
  color: #334155;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  padding: 0;
}

.folder-name {
  color: #d97706;
  font-weight: 700;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

/* KO'PROQ YUKLASH */
.load-more-row {
  text-align: center;
  padding: 15px !important;
}

.load-more-btn {
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 8px 30px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.load-more-btn:hover {
  background: #a142f4;
  color: white;
}

/* FOOTER */
.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px !important;
  color: #94a3b8;
  font-style: italic;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }

  .modern-search {
    width: 100%;
  }
}

/* ═════════════ 🏷 SHTRIX TANLASH ═════════════ */
.barcode-fab { position: relative; }
.barcode-fab.active { background: #5850ec !important; color: white !important; }
.badge-count {
  position: absolute; top: -6px; right: -6px;
  background: #ef4444; color: white;
  font-size: 10px; font-weight: 900;
  min-width: 18px; height: 18px; padding: 0 5px;
  border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
}
.icon-btn.barcode {
  background: #fef3c7; color: #92400e;
}
.icon-btn.barcode:hover { background: #f59e0b; color: white; }

/* Modal overlay */
.bc-overlay {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.5);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.bc-modal {
  background: white;
  border-radius: 20px;
  width: 900px; max-width: 96vw;
  max-height: 90vh;
  display: flex; flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
}
.bc-head {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.bc-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.bc-close {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
}
.bc-body { padding: 16px 22px; overflow-y: auto; flex: 1; }
.bc-foot {
  padding: 14px 22px; border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px; justify-content: flex-end;
}

.bc-options {
  display: flex; align-items: center; gap: 16px;
  margin-bottom: 14px;
  padding: 10px 14px;
  background: #f8fafc; border-radius: 10px;
}
.bc-opt { display: flex; flex-direction: column; gap: 4px; }
.bc-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; }
.bc-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.bc-toggle { display: flex; align-items: center; gap: 6px; cursor: pointer; user-select: none;
  font-size: 13px; font-weight: 600; color: #475569;
}
.bc-btn-clear {
  background: #fff1f2; color: #e11d48; border: 1.5px solid #fda4af;
  height: 36px; padding: 0 14px; border-radius: 8px;
  font-weight: 700; font-size: 12px; cursor: pointer;
}
.bc-btn-clear:hover { background: #e11d48; color: white; }

/* 🎯 Bulk-set */
.bc-bulk-row { display: flex; gap: 6px; align-items: center; }
.bc-btn-apply {
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none;
  height: 32px; padding: 0 12px;
  border-radius: 8px;
  font-weight: 800; font-size: 12px; cursor: pointer;
}
.bc-btn-apply:hover { opacity: 0.92; }

.bc-empty {
  text-align: center; padding: 40px 20px;
  color: #94a3b8; font-weight: 600;
}
.bc-table {
  width: 100%; border-collapse: collapse;
}
.bc-table th {
  background: #f8fafc; padding: 10px;
  font-size: 11px; font-weight: 800; color: #64748b;
  text-transform: uppercase; text-align: left;
  border-bottom: 1.5px solid #e8edf3;
}
.bc-table td {
  padding: 10px; border-bottom: 1px solid #f1f5f9;
  font-size: 13px; color: #1e293b;
}
.bc-pname { font-weight: 700; }
.bc-warn { font-size: 11px; color: #b91c1c; font-weight: 700; margin-top: 2px; }
.bc-mono { font-family: 'JetBrains Mono', monospace; font-weight: 700; color: #5850ec; }
.bc-qty {
  width: 80px; height: 32px;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 14px; font-weight: 700;
  text-align: center; outline: none;
}
.bc-qty:focus { border-color: #5850ec; }
.bc-btn-x {
  background: #fff1f2; color: #e11d48;
  border: none; width: 30px; height: 30px;
  border-radius: 8px; cursor: pointer;
}
.bc-btn-x:hover { background: #e11d48; color: white; }
.bc-table tfoot td { background: #f1f5f9; padding: 12px 10px; }

.bc-btn-cancel {
  background: #f1f5f9; color: #64748b;
  border: none; height: 42px; padding: 0 20px;
  border-radius: 10px; font-weight: 700; cursor: pointer;
}
.bc-btn-print {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white; border: none;
  height: 42px; padding: 0 24px;
  border-radius: 10px; font-weight: 800; cursor: pointer;
  display: flex; align-items: center; gap: 8px;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.35);
}
.bc-btn-print:hover:not(:disabled) { opacity: 0.92; }
.bc-btn-print:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
